'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _tableBody = require('../../table-body');

var _tableBody2 = _interopRequireDefault(_tableBody);

var _tableHeader = require('../../table-header');

var _tableHeader2 = _interopRequireDefault(_tableHeader);

require('../styles/Table.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_BcReactComponent) {
  _inherits(Table, _BcReactComponent);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {
      currentSortField: '',
      sortDirection: 'asc'
    };
    _this.bindAll('trimFields', 'sortRows', 'changeSortField');
    return _this;
  }

  _createClass(Table, [{
    key: 'componentDidMount',
    value: function componentDidMount() {} /* testing goodness */

    /*
      Field objects can provide their own sort method which will be used for comparison.
      This method will receive the list of rows, the current sort field, and the current
      sort direction as parameters, and must return a List of sorted rows.
    */

  }, {
    key: 'sortRows',
    value: function sortRows(fields) {
      var _props = this.props,
          rows = _props.rows,
          sortable = _props.sortable;
      var _state = this.state,
          currentSortField = _state.currentSortField,
          sortDirection = _state.sortDirection;

      var sortFieldObj = _lodash2.default.find(fields, { key: currentSortField });

      if (sortable && currentSortField && _lodash2.default.some(fields, { key: currentSortField })) {
        if (sortFieldObj.sort) {
          return sortFieldObj.sort(rows, currentSortField, sortDirection);
        }

        return Table.defaultSort(rows, currentSortField, sortDirection);
      }

      return rows;
    }
  }, {
    key: 'trimFields',
    value: function trimFields() {
      // return only fields which appear in the data.
      var _props2 = this.props,
          fields = _props2.fields,
          rows = _props2.rows,
          hideColumnsWithNoData = _props2.hideColumnsWithNoData;


      if (hideColumnsWithNoData) {
        return fields.filter(function (field) {
          var keys = field.key.split('.');
          return rows.some(function (val) {
            return val.getIn(keys);
          });
        });
      }

      return fields;
    }
  }, {
    key: 'changeSortField',
    value: function changeSortField(sortField) {
      if (this.state.currentSortField === sortField) {
        this.setState({ sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc' });
      } else {
        this.setState({ currentSortField: sortField });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fields = this.trimFields();
      var _props3 = this.props,
          intl = _props3.intl,
          stackedOnMobile = _props3.stackedOnMobile,
          hasLeftAlignedCheckbox = _props3.hasLeftAlignedCheckbox,
          _props3$className = _props3.className,
          customClassName = _props3$className === undefined ? 'table-striped' : _props3$className;

      var className = (0, _classnames2.default)('table cp-table', { 'stacked-on-mobile': stackedOnMobile }, customClassName);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { 'aria-live': 'polite' },
          this.state.currentSortField ? _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'table_sorted_by',
            values: {
              field: intl.formatMessage({ id: this.state.currentSortField }),
              direction: intl.formatMessage({ id: this.state.sortDirection })
            } }) : ''
        ),
        _react2.default.createElement(
          'table',
          { className: className + ' ' + (hasLeftAlignedCheckbox ? 'has-left-aligned-checkbox' : '') },
          _react2.default.createElement(
            'caption',
            null,
            this.props.caption
          ),
          _react2.default.createElement(_tableHeader2.default, {
            fields: this.trimFields(),
            sortable: this.props.sortable,
            changeSortField: this.changeSortField,
            sortDirection: this.state.sortDirection,
            currentSortField: this.state.currentSortField }),
          _react2.default.createElement(_tableBody2.default, {
            rows: this.sortRows(fields),
            fields: fields })
        )
      );
    }
  }], [{
    key: 'defaultSort',
    value: function defaultSort(rows, sortField, sortDirection) {
      return rows.sort(function (a, b) {
        var comparator = 0;
        // Catch if a field is passed in as a reference to a value in an object
        var normalizedField = sortField.split('.');

        var aValue = a.getIn(normalizedField);
        var bValue = b.getIn(normalizedField);

        if (aValue && bValue) {
          if (sortDirection === 'asc') {
            comparator = aValue < bValue ? -1 : 1;
          } else {
            comparator = aValue < bValue ? 1 : -1;
          }
        }

        if (aValue && !bValue) {
          comparator = sortDirection === 'asc' ? 1 : -1;
        }

        if (!aValue && bValue) {
          comparator = sortDirection === 'asc' ? -1 : 1;
        }

        return comparator;
      });
    }
  }]);

  return Table;
}(_baseBcReactComponent2.default);

Table.propTypes = {
  rows: _reactImmutableProptypes2.default.list.isRequired,
  /**
   * List of columns for the table. Each field takes an optional localizationMap
   * and sort comparator method.
   */
  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    key: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string.isRequired,
    localizationMap: _react.PropTypes.func,
    headerKey: _react.PropTypes.string,
    sort: _react.PropTypes.func,
    leftAlignedCheckbox: _react.PropTypes.bool,
    noWrap: _react.PropTypes.bool,
    rightAlign: _react.PropTypes.bool
  }).isRequired),
  caption: _react.PropTypes.string,
  /**
   * Adds sorting buttons to the table headers and allows for sorting of rows
   * by field. Default sort is ascending/descending, and a custom sort can
   * be added to each field if necessary.
   */
  sortable: _react.PropTypes.bool,
  intl: _reactIntl.intlShape,
  hideColumnsWithNoData: _react.PropTypes.bool,
  hasLeftAlignedCheckbox: _react.PropTypes.bool
};

Table.defaultProps = {
  rows: [],
  fields: [],
  sortable: false,
  caption: '',
  stackedOnMobile: true,
  hideColumnsWithNoData: true
};

exports.default = (0, _reactIntl.injectIntl)(Table);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table/components/Table.component.js
// module id = 1355
// module chunks = 1